<template>
  <div id="page-battery-daily">
    <el-form
      class="search-form"
      ref="searchForm"
      label-width="6em"
      :inline="true"
      :model="searchForm"
    >
      <el-row>
        <el-form-item label="统计日期" required>
          <filter-date-range
            :value.sync="dateRange"
            :range="30"
            :init-range="1"
            :startDate="startDate"
            required
          />
        </el-form-item>
        <el-form-item label="合作商" required>
          <filter-businessline-partner
            required
            :value.sync="searchForm.supplierId"
            :code.sync="supplierCode"
            :businessLine="businessLine"
            @initFetch="handleQuery(true)"
          />
        </el-form-item>
        <el-form-item label="Region">
          <filter-businessline-region
            multiple
            :value.sync="searchForm.regionId"
            :businessLine="businessLine"
          />
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="handleQuery(true)"> 查询 </el-button>
          <el-button @click="exportData" :loading="exportLoading" :disabled="isDisableExport">
            导出
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <section class="data-container">
      <common-report-table
        ref="table"
        url="getGenericData"
        tableAlign="right"
        :type="2"
        :showHeaderTip="true"
        :export.sync="isDisableExport"
        :filterParams="filterParams"
        @detail="handleDetail"
      />
    </section>
  </div>
</template>

<script>
import qs from 'qs'
import { dateFormat } from '@/utils'
import exportData from '@/mixins/exportData'
import lxUtils from '@/mixins/lx'

export default {
  mixins: [exportData, lxUtils],
  data() {
    const { regionId, supplierCode } = this.$route.query
    return {
      cid: 'c_mobikeops_ebikeBusiness_data_ChangeBattery_daily_sacan',
      businessLine: 2,
      startDate: Date.now() - 24 * 60 * 60 * 1000,
      isDisableExport: true,
      dateRange: [],
      supplierCode: supplierCode,
      searchForm: {
        ...this.$route.query,
        regionId: regionId ? regionId.split(',') : [],
      },
      // 导出
      exportFileName: '换电日报',
      exportUrl: 'exportReportData',
    }
  },

  computed: {
    filterParams() {
      const [date, endDate] = this.dateRange
      return {
        pageId: 'renew_battery_daily',
        date: dateFormat(date, 'yyyy-MM-dd'),
        endDate: dateFormat(endDate, 'yyyy-MM-dd'),
        supplierCodeList: this.supplierCode ? [this.supplierCode] : [],
        regionIdList: this.searchForm.regionId,
      }
    },
    exportParams() {
      const params = {
        ...this.filterParams,
        supplierCodeList: this.filterParams.supplierCodeList.join(','),
        regionIdList: this.filterParams.regionIdList.join(','),
      }
      delete params.pageNo
      return params
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const { date, endDate } = this.$route.query
      if (date && endDate) {
        this.dateRange = [date, endDate]
      }
    },
    handleQuery(init = false) {
      if (!this.searchForm.supplierId) {
        this.$message.error('合作商不能为空')
        return
      }
      this.$refs.table && this.$refs.table.fetchData(init, this.filterParams)
    },
    handleDetail({ row, item }) {
      const date = new Date(row.date).getTime()
      const params = {
        date,
        supplierId: this.searchForm.supplierId,
        supplierCode: this.supplierCode,
        regionId: row.regionCodeAttributeofdimRegionId.replace('R', ''),
      }
      let path = ''
      if (['有效换电量'].includes(item.name)) {
        path = 'battery/change-power' // 换电明细
      }
      this.$router.push(`/data/${path}?${qs.stringify(params)}`)
    },
  },
}
</script>

<style scoped lang="scss">
#page-battery-daily {
  overflow: hidden;
  .data-container {
    margin-top: 20px;
  }
}
</style>
